<template>
  <div class="c-lazy-tasks">
    <p class="sys-info">可通过右上角头像菜单<b>异步任务</b>打开此面板</p>
    <crud v-if="cfg" :cfg="cfg" />
  </div>
</template>
<script>
import { Crud, DataList } from "javaee-fre";
export default {
  name: "lazy-tasks",
  components: {
    crud: Crud,
  },
  data() {
    return {
      cfg: false,
    };
  },
  methods: {
    parseErrors(json) {
      let self = this;
      if (!json || json.length < 1) {
        return;
      }
      //检测row,col
      let row = json[0].row, headers = [{ label: "学员编号", name: "id" },
      { label: "姓名", name: "name" },
      { label: "自定义编号", name: "cid" }];
      if (row) {
        headers = [{ label: "行", name: "row" },
        { label: "列", name: "col" },
        { label: "说明", name: "message" }];
      }

      self.$dialog.component("有问题未导入列表", DataList, {
        width: 600,
        heads: headers,
        data: json
      });
    },
    parseFeedback(task) {
      let self = this,
        s = this.$dictVal(task.status), json = null, msg = null;
      if (task.feedback) {
        try {
          json = JSON.parse(task.feedback)
        } catch {
          msg = task.feedback;
        }
      }
      //如果处理成功，直接给反馈
      if (s == 3) {
        if (msg) {
          self.$status(msg, 'success');
        } else if (json) {
          let parsed = json.parsed, unParsed = json.unParsed;
          if (parsed || unParsed) {
            parsed = parsed || 0;
            unParsed = unParsed || 0;
            self.$status(
              unParsed > 0
                ? `成功导入${parsed}条，未导入${unParsed}`
                : `成功导入${parsed}条`,
              "success"
            );
            json = json.excelErrors;
          }
          self.parseErrors(json);
        } else {
          self.$status('处理成功～', 'success');
        }
        return;
      }

      if (msg) {
        self.$status(msg, 'error');
        return;
      } else if (json) {
        self.parseErrors(json);
      } else {
        self.$status('处理过程中出现错误～', 'error');
      }
    },
    init() {
      let self = this;
      self.cfg = {
        url: "/home/my/lazy/task",
        hideSeqNo: true,
        listItemActions: [
          {
            label: "处理信息",
            flag: "parse-info",
            icon: "info",
            func(cfg) {
              self.parseFeedback(cfg.item);
            }
          }, {
            label: '下载附件', icon: 'file_download', func(cfg) {
              window.open(`${self.$const.baseUrl}/home/my/lazy/task/attach/${cfg.item.id}`, '_blank');
            }
          }
        ],
        listItemFilter(i, acts) {
          let s = this.$dictVal(i.status);
          if (s != 2 && s != 3) {
            this.delAction(acts, "flag", "parse-info");
          }
          if (!i.attach) {
            this.delAction(acts, "icon", "file_download");
          }
          return acts;
        },
      };
    },
  },
  created() {
    this.init();
  }
};
</script>
<style scoped>
.c-lazy-tasks {
  padding-top: 8px;
}
</style>
